<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import Qs from 'qs'
import axios from '@/utils/request'

//交易账户状态
const accountStatusList = {
  'A': '已激活',
  'S': '冻结',
  'D': '销户',
  'T': '测试',
  'BL': '黑名单',
  'N': '未激活'
}

function getToday() {
  return formatDate(new Date())
}

function getTomorrow() {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return formatDate(tomorrow)
}

function formatDate(date) {
  let year = date.getFullYear()
  let month = (date.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的，所以要加1并确保是两位数
  let day = date.getDate().toString().padStart(2, '0')
  let time = year + '/' + month + '/' + day
  console.info(time)
  return time
}

function getTimestr() {
  return [getToday(), getTomorrow()]
}

export default {
  name: 'fundingList',
  components: {
    FORM,
    tablePage
  },

  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '账号', field: 'customerNumber' },
          {
            title: '激活时间',
            field: 'time',
            type: 6,
            data: getTimestr(),
            format: 'yyyy/MM/dd',
            startEndParam: ['startTime', 'endTime']
          },
          { title: '交易账户状态', field: 'accountStatusCode', type: 2, optionList: accountStatusList},
          { click: window.$t('common.search') },
          { click: window.$t('common.export'), auth: 'analyse:funding:export' },

        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.sleeping.fundingList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { field: 'customerNumber', title: '会员账号' },
          { field: 'name', sWidth: '200px', title: '姓名' },
          { field: 'email', sWidth: '200px', title: '邮箱' },
          { field: 'activeDate', title: '激活时间' },
          { field: 'accountGroup', title: '账户组别' },
          { field: 'utm', title: '媒介' },
          { field: 'paymentGatewayTags', title: '支付网关标记' },
          { field: 'payVerificationMark', title: '支付验证标记' },
          { field: 'accountLevelCode', title: '用戶类型' },
          { field: 'accountStatusCode', title: '交易账户状态' },
          { field: 'remark', title: '后台客户维护标记' },
          { field: 'firstDeposit', title: '首次存款金额' },
          { field: 'recentDepositTime', title: '最近存款時間' },
          { field: 'recentWithdrawalTime', title: '最近取款時間' },
          { field: 'totalOfDeposits', title: '总入金' },
          { field: 'totalOfWithdrawals', title: '总出金' },
          { field: 'netDeposit', title: '净入金' },
          { field: 'numberOfDeposits', title: '入金次数' },
          { field: 'numberOfWithdrawals', title: '出金次数' },
          { field: 'startTime', title: '統計起始时间' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: '同步',
                click: 'synData',
                type: 'primary',
                icon: 'el-icon-editRebate',
                auth: 'analyse:funding:syn'
              }
            ]
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'synData') {
        this.synData(row)
      }
    },synData: function(row) {
      console.info(row)
      this.dataChange(Url.sleeping.fundingSynCustomers, row, res => {
        this.$message.success(res.message)
      })
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.formatDate(data)
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('导出' == clickName || window.$t('common.export') == clickName) {
        this.formatDate(data)
        download.exportExcel(Url.sleeping.fundingDown, data, 'A客户新客户')
      }
    },
    formatDate(data) {
      data.startTime = data.startTime ? new Date(data.startTime).getTime() : 0
      data.endTime = data.endTime ? new Date(data.endTime).getTime() : 0
    }
  },
  mounted() {

  }
}
</script>

